import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import QuestionSections from "./edit/QuestionSections";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as FormActionCreator from "../../redux/creators/form";
import CollapsiblePanel from "../base/CollapsiblePanel";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

class FormEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_form: "/form/save/:form",
			get_form: "/form/fetch/:form"
		});

		this.state = {
			loaded: false,
			asNew: false,
		};
	}

	fetchData() {
		this.api.request({
			route: "get_form",
			params: { form: this.props.params.formID },
			success: (response) => {
				this.props.addForm(response);
				this.setState({ loaded: true });
			}
		});
	}

	saveData(asNew = false) {
		this.api.request({
			route: "save_form",
			params: { form: !asNew ? this.props.params.formID : "new" },
			data: this.props.form,
			created: (response) => {
				browserHistory.push("/forms");
			},
			failure: (response) => {
				let error_message = "";
				for (let field in response.message) {
					error_message += translate("Field %s is required").replace("%s", field) + "\n";
				}
				alert(error_message);
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onFormChange(evt) {
		let newForm = this.props.form;
		newForm[evt.target.name] = evt.target.value;
		this.props.addForm(newForm);
	}

	onFormSave(evt) {
		this.saveData();
	}

	onFormSaveNew(evt) {
		this.saveData(true);
	}

	render() {

		if (!this.state.loaded) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page bsClass="container-fluid">
				<PageHeader title={this.props.form.name} />
				<PageBody>
					<Row>
						<Col lg={12}>
							<Panel header={translate("Základné informácie")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.props.form.name} name="name"
										onChange={this.onFormChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<CollapsiblePanel title={translate("Sekcie otázok")} expanded={true}>
								<QuestionSections />
							</CollapsiblePanel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<button className="btn btn-success" onClick={this.onFormSave.bind(this)}>{translate("Uložiť")}</button>
								<button className="btn btn-primary" style={{marginLeft: "1rem"}} onClick={this.onFormSaveNew.bind(this)}>{translate("Uložiť ako nové")}</button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ addForm: FormActionCreator.addFormAction }, dispatch);
}

export default connect(state => ({ form: state.form }), matchDispatchToProps)(FormEdit);


// WEBPACK FOOTER //
// ./src/modules/form/FormEdit.js